import React, { useState, useEffect } from 'react'
import { Modal, Form, InputNumber, App } from 'antd'
import { useDingdanzhichuCWCHMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'
import dayjs from 'dayjs'
function CostFinanceAmount(props) {
  const { message } = App.useApp()
  const [open, setOpen] = useState(false)
  const [info, setInfo] = useState({
    ddzc_id:props.ddzc_id,
    ddzc_state: props.ddzc_state,
    ddzc_cw_content:'',
    ddzc_amount:props.ddzc_amount,
  })
  const [form] = Form.useForm()
  const [updateSave] = useDingdanzhichuCWCHMutation()
  useEffect(() => {
    form.setFieldsValue({
        ddzc_id:props.ddzc_id,
        ddzc_state: props.ddzc_state,
        ddzc_cw_content:'',
        ddzc_amount:props.ddzc_amount,
    })
  }, [props.ddzc_id, props.ddzc_state, props.ddzc_amount, form])
  return (
    <>
        <Icon type='financeAmount' onClick={() => setOpen(true)} />
        <Modal
            title='财务改金额'
            open={open}
            onCancel={() => setOpen(false)}
            onOk={() => {
                updateSave({
                    ddzc_id:props.ddzc_id,
                    ddzc_state: props.ddzc_state,
                    ddzc_cw_content:props.ddzc_cw_content+`！${dayjs().format('YYYY-MM-DD HH:mm:ss')} 财务操作：财务改金额，原始价格为${props.ddzc_amount}`,
                    ddzc_amount:info.ddzc_amount,
                }).then((res) => {
                    if(res.data.Status === 'success') {
                        message.success('财务改金额成功！')
                        setOpen(false)
                    } else {
                        message.error('财务改金额失败！'+res.data.Message)
                    }
                }).catch((err) => {
                    message.error('财务改金额失败！'+err.message)
                })
            }}
        >
            <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
                <Form.Item label='金额' name='ddzc_amount' rules={[{ required: true, message: '请输入金额' }]}>
                    <InputNumber 
                        min={0.01} 
                        max={99999999.99} 
                        step={0.01} 
                        onChange={(value) => {
                            setInfo(prev => ({ ...prev, ddzc_amount: value }))
                        }}
                        style={{ width: '100%' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    </>
  )
}


export default CostFinanceAmount